import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=134b76ee&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=134b76ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b76ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134b76ee')) {
      api.createRecord('134b76ee', component.options)
    } else {
      api.reload('134b76ee', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=134b76ee&scoped=true&", function () {
      api.rerender('134b76ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/dashboard/Index.vue"
export default component.exports